import React from 'react';
import BemClass from '@upsales/components/Utils/bemClass';
import { Icon, Block, IconName, Colors } from '@upsales/components';

import './TimelineIcon.scss';

type Props = {
	name?: IconName;
	color?: Colors;
	backgroundColor?: Colors;
	hideLine?: boolean;
};

const TimelineIcon = ({ name, color, backgroundColor, hideLine = false }: Props) => {
	const classNames = new BemClass('TimelineIcon');

	if (!name) {
		return null;
	}

	return (
		<div className={classNames.b()}>
			<Block backgroundColor={backgroundColor || undefined} className={classNames.elem('iconCard').b()}>
				<Icon name={name} color={color || 'grey-10'} />
			</Block>
			{!hideLine ? <div className={classNames.elem('line').b()} /> : null}
		</div>
	);
};

export default TimelineIcon;
